import { Expose } from "class-transformer";
import { PgaPolicy } from "./pga-policy.model";

export class LifePolicy extends PgaPolicy {
    @Expose() status = ""; // S - V
}
